import { render, staticRenderFns } from "./my_trainings.vue?vue&type=template&id=b4f17840"
import script from "./my_trainings.vue?vue&type=script&lang=js"
export * from "./my_trainings.vue?vue&type=script&lang=js"
import style0 from "./my_trainings.vue?vue&type=style&index=0&id=b4f17840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports